import { useContext } from "react";
import { ImperativeDialogContext, DialogHeader, DialogTitle } from "@repo/ui";
import type { Workflow } from "~/types/api";
import { useWorkflowCreationContext } from "../workflow-creation-context-provider";
import { ActionView } from "../workflows-dialog/views/action-view/action-view";
import { MetadataView } from "../workflows-dialog/views/metadata-view/metadata-view";
import { StatusView } from "../workflows-dialog/views/status-view/status-view";

export const useWorkflowEditDialogs = () => {
  const dialogContext = useContext(ImperativeDialogContext);
  const { closeDialog, showDialog } = dialogContext ?? {};
  const { updateState } = useWorkflowCreationContext();

  const showEditMetadataDialog = (workflow: Workflow) => {
    showDialog?.({
      content: (
        <div className="flex flex-col gap-6">
          <DialogHeader>
            <DialogTitle>Edit Metadata Fields - {workflow.name}</DialogTitle>
          </DialogHeader>
          <MetadataView isEditMode workflowId={workflow.id} onClose={closeDialog} />
        </div>
      ),
      onClose: closeDialog,
    });
  };

  const showEditStatusesDialog = (workflow: Workflow) => {
    showDialog?.({
      content: (
        <div className="flex flex-col gap-6">
          <DialogHeader>
            <DialogTitle>Edit Item Statuses - {workflow.name}</DialogTitle>
          </DialogHeader>
          <StatusView isEditMode workflowId={workflow.id} onClose={closeDialog} />
        </div>
      ),
      onClose: closeDialog,
    });
  };

  const showEditActionsDialog = (workflow: Workflow) => {
    updateState("actions", []);
    updateState("activeActionId", null);
    showDialog?.({
      content: (
        <div className="flex flex-col gap-6">
          <DialogHeader>
            <DialogTitle>Edit Item Actions - {workflow.name}</DialogTitle>
          </DialogHeader>
          <ActionView isEditMode workflowId={workflow.id} onClose={closeDialog} />
        </div>
      ),
      contentClassName: "max-w-4xl",
      onClose: closeDialog,
    });
  };

  return { showEditMetadataDialog, showEditStatusesDialog, showEditActionsDialog, closeDialog };
};
